module.exports = __webpack_public_path__ + "img/3-1.08b2ee4c.png";